import React from 'react';
import {Observer} from "mobx-react-lite";
import TabOption from "../../ui_components/Tab/TabOption";
import PlaceIcon from '@mui/icons-material/Place';
import Tabs from "../../ui_components/Tab/Tabs";
import {useUserContext} from "../../contexts/UserContext";
import GeoConfigsTab from './tabs/GeoConfigs/GeoConfigsTab';
// import DocumentSettingsTab from './tabs/DocumentSettings/DocumentSettingsTab';
// import DescriptionIcon from '@mui/icons-material/Description';
// import {useI18nContext} from "../../contexts/I18nContext";
import { useStyles } from './Configurations.style';

const Configurations: React.FC = () => {
    // const commonStore = useCommonContext();
    const userStore = useUserContext();
    // const store = new ConfigurationsStore(commonStore);
    const classes = useStyles();

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    return (
        <Observer>{() => {
            const tabsContent = [
                new TabOption("Municipios", <GeoConfigsTab/>, <PlaceIcon/>),
                // Document settings are configured per agency from the agency list
                // (Agencias -> menú -> Configuraciones), so this tab stays hidden.
                // new TabOption(i18n.translate("DOCUMENT_SETTINGS"), <DocumentSettingsTab/>, <DescriptionIcon/>),
            ];
            return (
                <div className={classes.dashboard_container}>
                    <div className={classes.box_container}>
                        <Tabs content={tabsContent} orientation='vertical' className={classes.tab_container_custom}/>
                    </div>
                </div>
            )
        }}
        </Observer>
    )
}

export default Configurations;
